import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import css from "./onetrust-modal-button.module.scss";
interface OneTrustModalButtonProps {
  label: string;
  ctaId?: string;
  ctaValue?: string;
}
export const OneTrustModalButton = props => {
  const $ = _c(8);
  const {
    label
  } = props;
  let handleClick;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    handleClick = () => {
      (window as any)?.Optanon?.ToggleInfoDisplay();
      updateLinkInModal();
    };
    const updateLinkInModal = _temp;
    $[0] = handleClick;
  } else {
    handleClick = $[0];
  }
  const t0 = props?.ctaId ?? "privacy-choices-link";
  const t1 = props?.ctaValue ?? "privacy-choices-link-bottom-footer";
  let t2;
  if ($[1] !== label) {
    t2 = <span>{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src="/onetrust-privacy-icon.png" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon" width={123} height={59} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t4 = <button id="onetrust-button" className={css.oneTrustButton} type="button" onClick={handleClick} data-cta-id={t0} data-cta-value={t1}>{t2}{t3}</button>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default OneTrustModalButton;
function _temp() {
  const privacyLink = document.querySelector(".privacy-notice-link");
  if (privacyLink && privacyLink instanceof HTMLAnchorElement) {
    privacyLink.href = "https://amerisave.com/legal/privacy-policy";
  } else {
    console.error("Could not find the privacy link in the modal or it is not an anchor element.");
  }
}